var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"material toggle",on:{"click":function($event){return _vm.toggle()}}},[_c('div',{staticClass:"frame",class:{
		on: _vm.checked,
	}},[_c('div',{staticClass:"pin"})]),(_vm.label)?_c('div',{staticClass:"text"},[_vm._v("\n\t\t"+_vm._s(_vm.label)+"\n\t\t"),(_vm.note)?_c('div',{staticClass:"note"},[_vm._v(_vm._s(_vm.note))]):_vm._e(),(_vm.tooltip)?_c('div',{staticClass:"tooltip"},[_vm._v(_vm._s(_vm.tooltip))]):_vm._e()]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }